import React, { useState } from "react";

const VideoDescription = ({ description, lines = 4 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!description) return null;

  // Split description into lines (or paragraphs)
  const linesArray = description.split("\n").filter(Boolean);
  const preview = linesArray.slice(0, lines).join("\n");

  return (
    <div
      className="p-3 rounded mb-3"
      style={{
      backgroundColor: "var(--bs-light)", 
      borderLeft: "4px solid var(--bs-primary)",
      color: "var(--bs-dark)",
      lineHeight: "2.5",
    }}
    >
      <strong>About this video: </strong>
      <div
        dangerouslySetInnerHTML={{
          __html: expanded ? description : preview,
        }}
      />
      {linesArray.length > lines && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="btn btn-link btn-sm p-0 mt-1"
          style={{ color: "#842029" }}
        >
          {expanded ? "Show Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

export default VideoDescription;
